import Logger from "../../../core/internal/logger"
import { InAppMessageScheduleActionDeterminer } from "./action/InAppMessageScheduleActionDeterminer"
import { InAppMessageScheduleListener } from "./InAppMessageScheduleListener"
import { InAppMessageScheduleRequest } from "./InAppMessageScheduleRequest"
import { InAppMessageScheduleResponse } from "./InAppMessageScheduleResponse"
import { InAppMessageSchedulerFactory } from "./scheduler/InAppMessageSchedulerFactory"

export class InAppMessageScheduleProcessor implements InAppMessageScheduleListener {
  constructor(
    private readonly actionDeterminer: InAppMessageScheduleActionDeterminer,
    private readonly schedulerFactory: InAppMessageSchedulerFactory
  ) {}

  process(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    Logger.log.debug(`InAppMessage Schedule Request: ${request}`)
    const response = this.schedule(request)
    Logger.log.debug(`InAppMessage Schedule Response: ${response}`)
    return response
  }

  private schedule(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    try {
      const action = this.actionDeterminer.determine(request)
      const scheduler = this.schedulerFactory.get(request.scheduleType)
      return scheduler.schedule(action, request)
    } catch (e) {
      Logger.log.error(`Failed to process InAppMessageSchedule: ${e}`)
      return InAppMessageScheduleResponse.of(request, "EXCEPTION")
    }
  }

  onSchedule(request: InAppMessageScheduleRequest) {
    this.process(request)
  }
}
